import React, { Component } from 'react'
import ReactPlayer from 'react-player'
// import RPlayer from './ReactPlayer'
import ReactSlider from 'react-slider'

import Front from '../Front';
import Menu from '../Menu';
import ControlArea from './ControlArea';
import EpisodeList from '../EpisodeList';
import EpisodeToggle from '../EpisodeToggle';
import hitApi from '../../app/services/playbackPositionApi';


class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			url: null,
			playing: false,
			volume: 1.0,
			muted: false,
			played: 0,
			loaded: 0,
			duration: 0,
			apiTimer:2,
			incrementValue:2,
			playbackRate: 1.0,
			loop: false,

			podcast: this.props.podcast,
			originalOrderedEpisodes: this.props.episodes,
			episodes: [...this.props.episodes].reverse(),
			episodeCount: this.props.episodes.length,
			activeEpisode: this.props.episodes[0],
			selectiveEpisodes: Array.isArray(this.props.episodesToShow) && this.props.episodesToShow.length ? this.props.episodesToShow : false,
			showEpisodes: false,
			showMenu: false,

			toShowOnlyParticularEpisode: false
		}
	}

	componentDidUpdate(prevProps, prevState) {
        
        const { played, duration, incrementValue } = this.state;
        const { played: prevPlayed, duration: prevDuration } = prevState;
    
        if ((played !== prevPlayed || duration !== prevDuration) && played * duration >= this.state.apiTimer) {
          this.setState((prevState) => ({
            apiTimer: prevState.apiTimer + prevState.incrementValue,
          }));
          this.handleHitApi();
        }
      }

      handleHitApi = () => {
        const { played, duration, activeEpisode } = this.state;
        hitApi(played, duration, activeEpisode)
          .then((data) => {    
          })
          .catch((error) => {
          });
      };

	componentDidMount() {
		if (this.props.onlyEpisode) { this.setState({ toShowOnlyParticularEpisode: true }) }
		
		if (this.state.selectiveEpisodes) {
			// filter through indexes in this.state.episodes
			const newEpisodeList = this.state.episodes.filter((ep, index) => {
				if (this.state.selectiveEpisodes.indexOf(index) > -1 ) {
					return ep;
				}
			});
			this.setState({
				episodes: newEpisodeList,
				originalOrderedEpisodes: [...newEpisodeList].reverse(),
				episodeCount: newEpisodeList.length,
				activeEpisode: newEpisodeList[0],
			})
		}

		// Check if episode param is valid and exists
		if (this.props.chosenEpisode && this.props.chosenEpisode > 0 && this.props.chosenEpisode <= this.state.episodeCount) {
			this.setState({ activeEpisode: this.state.episodes[this.props.chosenEpisode-1] }, () => {
				const originalUrl = this.state.activeEpisode.enclosure.url;
				// Split at the first '?' and take the first piece (the base URL).
				const baseUrl = originalUrl.split('?')[0];
				// Build your new URL with a single query parameter.
				const finalUrl = baseUrl + '?s=hh-embed-player-v1';
				// Pass finalUrl to .load
				this.load(finalUrl, this.state.activeEpisode)
			})

		} else {
			const originalUrl = this.state.activeEpisode.enclosure.url;
			// Split at the first '?' and take the first piece (the base URL).
			const baseUrl = originalUrl.split('?')[0];
			// Build your new URL with a single query parameter.
			const finalUrl = baseUrl + '?s=hh-embed-player-v1';
			// Pass finalUrl to .load
			this.load(finalUrl, this.state.originalOrderedEpisodes[0])
		}
	}
	
	playEpisode = (episode) => {
		this.setState({activeEpisode: episode})
		const originalUrl = episode.enclosure.url;
		// Split at the first '?' and take the first piece (the base URL).
		const baseUrl = originalUrl.split('?')[0];
		// Build your new URL with a single query parameter.
		const finalUrl = baseUrl + '?s=hh-embed-player-v1';
		// Pass finalUrl to .load
		this.load(finalUrl, episode);
		this.handlePlay()
	}

	playNextEpisode = () => {
		let currEpIndex = this.state.episodes.findIndex(episode => episode.guid === this.state.activeEpisode.guid);
		if (currEpIndex < (this.state.episodeCount-1)) {
			this.load(this.state.episodes[currEpIndex+1].enclosure.url, this.state.episodes[currEpIndex+1])
			this.handlePlay()
		}
	}

	playPreviousEpisode = () => {
		let currEpIndex = this.state.episodes.findIndex(episode => episode.guid === this.state.activeEpisode.guid);
		if (currEpIndex > 0) {
			this.load(this.state.episodes[currEpIndex-1].enclosure.url, this.state.episodes[currEpIndex-1])
			this.handlePlay()
		}
	}

	load = (url, episode) => {
		const originalUrl = url;
		// Split at the first '?' and take the first piece (the base URL).
		const baseUrl = originalUrl.split('?')[0];
		// Build your new URL with a single query parameter.
		const finalUrl = baseUrl + '?s=hh-embed-player-v1';
		// Pass finalUrl to .load
		this.setState({
			url: finalUrl,
			played: 0,
			loaded: 0,
			pip: false,
			activeEpisode: episode
		})
	}

	handlePlayPause = () => {
		this.setState({ playing: !this.state.playing })
	}

	handleStop = () => {
		this.setState({ url: null, playing: false })
	}

	handleToggleLoop = () => {
		this.setState({ loop: !this.state.loop })
	}

	handleVolumeChange = e => {
		this.setState({ volume: parseFloat(e.target.value) })
	}

	handleToggleMuted = () => {
		this.setState({ muted: !this.state.muted })
	}

	handleSetPlaybackRate = e => {
		this.setState({ playbackRate: parseFloat(e.target.value) })
	}

	handlePlay = () => {
		this.setState({ playing: true })
	}

	handlePause = () => {
        this.handleHitApi();
        this.setState({ playing: false })
    }

	handleSeekMouseDown = e => {
		this.setState({ seeking: true })
	}

	handleSeekChange = e => {
		this.setState({ played: parseFloat(e) })
	}

	handleSeekMouseUp = e => {
		this.setState({ seeking: false })
		this.player.seekTo(parseFloat(e))
	}

	rewind = () => {
		this.player.seekTo(parseFloat(this.state.playedSeconds - 15))
	}

	fastForward = () => {
		this.player.seekTo(parseFloat(this.state.playedSeconds + 15))
	}

	handleProgress = state => {
	    // We only want to update time slider if we are not currently seeking
	    if (!this.state.seeking) {
	    	this.setState(state)
	    }
	}

	handleEnded = () => {
        this.setState({ playing: this.state.loop ,played:1})
        this.handleHitApi();
    }

	handleDuration = (duration) => {
        this.setState({ duration });
    
        if (duration <= 300) {
          this.setState({ apiTimer: 2, incrementValue: 2 });
        } else if (duration <= 600) {
          this.setState({ apiTimer: 3, incrementValue: 3 });
        } else if (duration <= 1200) {
          this.setState({ apiTimer: 5, incrementValue: 5 });
        } else if (duration <= 2400) {
          this.setState({ apiTimer: 10, incrementValue: 10 });
        } else {
          this.setState({ apiTimer: 15, incrementValue: 15 });
        }
      }

	ref = player => {
		this.player = player
	}

	toggleEpisodesShow = () => {
		this.setState({
			showEpisodes: !this.state.showEpisodes
		})
		// , () => {  if (this.state.showEpisodes) { window.scrollTo(0, this.refs.episodesList.offsetTop); } })
	}

	toggleMenu = () => {
		this.setState({
			showMenu: !this.state.showMenu
		})
	}

	render () {
		const { url, playing, controls, volume, muted, loop, played, duration, playbackRate } = this.state;

		return (
			<div className='wrapper'>
				<div className="player">
					<div className="head" style={{ display: this.state.showEpisodes ? 'none' : 'block' }} >
						
						<div className="back"></div>
						
						<Menu episode={this.state.activeEpisode} podcast={this.state.podcast} showMenu={this.state.showMenu}/>
						
						<Front
							podcast={this.props.podcast}
							activeEpisode={this.state.activeEpisode}
							showMenu={this.state.showMenu}
							toggleMenu={this.toggleMenu}
						/>

					</div>
					
					<div className="timeline" style={{ height: this.state.toShowOnlyParticularEpisode ? '65px' : '75px' }}>
						
						<ReactSlider 
							className="soundline"
							value={played}
							max={1}
							step={0.000000000000001}
						    trackClassName="playingTrack"
						    onChange={this.handleSeekChange}
						    onSliderClick={this.handleSeekMouseUp}
						    onBeforeChange={this.handleSeekMouseDown}
						    onAfterChange={this.handleSeekMouseUp}
						    renderThumb={(props, state) => <div {...props}></div>}
						/>
						
						<ControlArea 
							duration={duration}
							playing={playing}
							played={played}
							rewind={this.rewind}
							playPreviousEpisode={this.playPreviousEpisode}
							handlePause={this.handlePause}
							handlePlay={this.handlePlay}
							playNextEpisode={this.playNextEpisode}
							fastForward={this.fastForward}
						/>

						{ !this.state.toShowOnlyParticularEpisode &&
							<EpisodeToggle toggleEpisodesShow={this.toggleEpisodesShow} showEpisodes={this.state.showEpisodes}/> 
						}
					
					</div>
					
					{ this.state.showEpisodes && !this.state.toShowOnlyParticularEpisode &&
						<EpisodeList
							order={this.props.order} 
							handlePause={this.handlePause}
							episodes={this.state.originalOrderedEpisodes}
							playing={playing}
							activeEpisodeGuid={this.state.activeEpisode.guid}
							playEpisode={this.playEpisode}
							height={this.props.height}
						/>
					}
				</div>

				<div className='player-wrapper' style={{display: 'none'}}>
					<ReactPlayer
						ref={this.ref}
						className='react-player'
						width='0px'
						height='0px'
						url={url}
						playing={playing}
						controls={controls}
						loop={loop}
						playbackRate={playbackRate}
						volume={volume}
						muted={muted}
						onReady={() => { /*console.log('onReady')*/ } }
						onStart={() => { /*console.log('onStart')*/ } }
						onPlay={this.handlePlay}
						onPause={this.handlePause}
						onBuffer={() => { /*console.log('onBuffer')*/ } }
						onSeek={e => { /*console.log('onSeek', e)*/ } }
						onEnded={this.handleEnded}
						onError={e => { /*console.log('onError', e)*/ } }
						onProgress={this.handleProgress}
						onDuration={this.handleDuration}
					/>
				</div>
			</div>
			)
	}
}

export default App
